var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_784_30",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 66,
    height: 66
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_784_30)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 7,
    width: 54,
    height: 9,
    fill: "#F00000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 23,
    width: 69,
    height: 9,
    fill: "#F00000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 40,
    width: 69,
    height: 9,
    fill: "#F00000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: 57,
    width: 69,
    height: 9,
    fill: "#F00000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -3,
    width: 39,
    height: 35,
    fill: "#0054B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 22L26.6735 24.0729H28.8532L27.0898 25.3541L27.7634 27.4271L26 26.1459L24.2366 27.4271L24.9102 25.3541L23.1468 24.0729H25.3265L26 22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 22L14.6735 24.0729H16.8532L15.0898 25.3541L15.7634 27.4271L14 26.1459L12.2366 27.4271L12.9102 25.3541L11.1468 24.0729H13.3265L14 22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 22L3.67354 24.0729H5.85317L4.08981 25.3541L4.76336 27.4271L3 26.1459L1.23664 27.4271L1.91019 25.3541L0.146831 24.0729H2.32646L3 22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13L14.6735 15.0729H16.8532L15.0898 16.3541L15.7634 18.4271L14 17.1459L12.2366 18.4271L12.9102 16.3541L11.1468 15.0729H13.3265L14 13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13L3.67354 15.0729H5.85317L4.08981 16.3541L4.76336 18.4271L3 17.1459L1.23664 18.4271L1.91019 16.3541L0.146831 15.0729H2.32646L3 13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 13L26.6735 15.0729H28.8532L27.0898 16.3541L27.7634 18.4271L26 17.1459L24.2366 18.4271L24.9102 16.3541L23.1468 15.0729H25.3265L26 13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 3L26.6735 5.07295H28.8532L27.0898 6.3541L27.7634 8.42705L26 7.1459L24.2366 8.42705L24.9102 6.3541L23.1468 5.07295H25.3265L26 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3L14.6735 5.07295H16.8532L15.0898 6.3541L15.7634 8.42705L14 7.1459L12.2366 8.42705L12.9102 6.3541L11.1468 5.07295H13.3265L14 3Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.5e0811d260e52160e59f43ad73be601f.svg";
export { ForwardRef as ReactComponent };